import { cva } from "@mobsuccess-devops/styled-system/css";

export const buttonStyles = cva({
  base: {
    display: "flex",
    alignItems: "center",
    borderRadius: "md",
    border: "none",
    boxSizing: "border-box",
    cursor: "pointer",
    fontFamily: '"Poppins", sans-serif',
    fontWeight: 500,
    transitionDuration: "0.2s",
    transitionTimingFunction: "ease-in-out",
    transitionProperty: "color, background, box-shadow",
    _disabled: {
      opacity: "0.5",
      cursor: "not-allowed",
    },
    _focus: {
      boxShadow:
        "0 0 0 4px color-mix(in srgb, token(colors.primary) 30%, transparent)",
    },
    _focusVisible: {
      outline: "none",
      boxShadow:
        "0 0 0 4px color-mix(in srgb, token(colors.primary) 30%, transparent)",
    },
  },
  variants: {
    fill: {
      true: {
        width: "full",
        justifyContent: "center",
      },
      false: {
        width: "fit-content",
      },
    },
    size: {
      xs: {
        height: "md",
        gap: "6px",
        padding: "6px",
        textStyle: "xs",
        borderRadius: "sm",
        _childSvg: {
          size: "xs",
        },
      },
      sm: {
        height: "32px",
        gap: "sm",
        padding: "8px",
        textStyle: "sm",
        _childSvg: {
          size: "sm",
        },
      },
      md: {
        height: "40px",
        gap: "10px",
        padding: "10px",
        textStyle: "md",
        _childSvg: {
          size: "20px",
        },
      },
      lg: {
        height: "48px",
        gap: "14px",
        padding: "14px",
        textStyle: "lg",
        _childSvg: {
          size: "md",
        },
      },
      xl: {
        height: "56px",
        gap: "md",
        padding: "md",
        textStyle: "xl",
        _childSvg: {
          size: "lg",
        },
      },
    },
    palette: {
      primary: { colorPalette: "primary" },
      secondary: { colorPalette: "secondary" },
      interface: { colorPalette: "interface" },
      success: { colorPalette: "success" },
      danger: { colorPalette: "danger" },
      warning: { colorPalette: "warning" },
      info: { colorPalette: "info" },
    },
    variant: {
      light: {
        color: "colorPalette.500",
        background: "colorPalette.100",
        boxShadow:
          "0 0 0 0 color-mix(in srgb, token(colors.colorPalette) 30%, transparent)",
        _focus: {
          boxShadow:
            "0 0 0 4px color-mix(in srgb, token(colors.colorPalette) 30%, transparent)",
        },
        "&:hover:enabled": {
          background: "colorPalette.200",
          color: "colorPalette.500",
        },
        "&:disabled": {
          background: "colorPalette.200",
          color: "colorPalette.500",
        },
      },
      dark: {
        color: "white",
        background: "colorPalette.400",
        boxShadow:
          "0 0 0 0 color-mix(in srgb, token(colors.colorPalette) 30%, transparent)",
        _focus: {
          boxShadow:
            "0 0 0 4px color-mix(in srgb, token(colors.colorPalette) 30%, transparent)",
        },
        "&:hover:enabled": {
          background: "colorPalette.500",
          color: "white",
        },
        "&:disabled": {
          background: "colorPalette.400",
          color: "white",
        },
      },
      outlined: {
        border: "1px solid",
        borderColor: "colorPalette.400",
        color: "colorPalette.400",
        background: "white",
        boxShadow:
          "0 0 0 0 color-mix(in srgb, token(colors.colorPalette) 30%, transparent)",
        _focus: {
          boxShadow:
            "0 0 0 4px color-mix(in srgb, token(colors.colorPalette) 30%, transparent)",
          borderColor: "colorPalette.400",
        },
        "&:hover:enabled": {
          color: "colorPalette.500",
          background: "colorPalette.100",
          borderColor: "colorPalette.500",
        },
        "&:disabled": {
          borderColor: "colorPalette.400",
        },
      },
      transparent: {
        color: "colorPalette.400",
        background: "none",
        _focus: {
          boxShadow:
            "0 0 0 4px color-mix(in srgb, token(colors.colorPalette) 30%, transparent)",
        },
        "&:hover:enabled": {
          color: "colorPalette.400",
          background: "colorPalette.100",
        },
        "&:disabled": {
          color: "colorPalette.400",
        },
      },
    },
    underline: {
      true: {
        "&:not(svg)": {
          underline: true,
        },
      },
    },
  },
  defaultVariants: {
    variant: "light",
    fill: false,
    size: "sm",
    /** @todo remove this default colorPalette to allow parent to default this value */
    palette: "primary",
    underline: true,
  },
});
